import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { FolderListPanel } from '../-components/folder-list-panel';
import { SearchResultsPanel } from '../-components/search-results-panel';

// Spam and trash are the same surface — a flat list of messages that can be put
// back — so they share one route tree with the folder in the path.
const folderSchema = z.enum(['spam', 'trash']);

export const Route = createFileRoute('/_dashboard/mailbox/$folder')({
  params: {
    parse: (params) => ({ folder: folderSchema.parse(params.folder) }),
    stringify: ({ folder }) => ({ folder }),
  },
  component: FolderMailboxRoute,
});

function FolderMailboxRoute() {
  const { folder } = Route.useParams();
  const { q } = Route.useSearch();
  const panel = q.trim() ? (
    <SearchResultsPanel />
  ) : (
    <FolderListPanel
      folder={folder}
      buildEmailLink={(emailId: string) => ({
        to: '/mailbox/$folder/$emailId',
        params: { emailId, folder },
      })}
    />
  );

  return (
    <div className="flex h-full overflow-hidden">
      {panel}
      <Outlet />
    </div>
  );
}
